import TooltipCustom from '__core/modules/atoms/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';

function OptionLabel({ label, value, tooltip, description }) {
  const content = (
    <div data-testid={`option-${value}`}>
      <div className="select-customizable__option-label">{label}</div>
      {description && <div className="select-customizable__option-description">{description}</div>}
    </div>
  );
  if (!tooltip) return content;
  return (
    <TooltipCustom title={tooltip} placement="right" variant="secondary">
      {content}
    </TooltipCustom>
  );
}

OptionLabel.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltip: PropTypes.string,
  description: PropTypes.node,
};

export default OptionLabel;
